import React from 'react';

export default function MesCommandesCommercantCell({ commercant }) {
  const nom = commercant?.nom?.trim();
  if (!nom) {
    return <span className="text-sm text-gray-400">—</span>;
  }
  const ville = [commercant?.codePostal, commercant?.ville].filter(Boolean).join(' ');
  return (
    <div className="min-w-0 max-w-full">
      <div className="font-semibold text-[14px] text-gray-900 leading-snug line-clamp-2" title={nom}>
        {nom}
      </div>
      {ville ? <div className="mt-0.5 text-xs text-gray-500 truncate">{ville}</div> : null}
    </div>
  );
}
